/*
 * Lemonade Training Oy, copy rights, all right reserved.
 */

/** The single key holding the whole capped list; the card writes it. */
export const RENEWAL_DISMISSED_STORAGE_KEY = "lemonade-renewal-dismissed";

/**
 * Drop the record of which renewal notices have been waved away.
 *
 * Swept on sign-out for the same reason as the settlement markers and the
 * image-variant cache. Not because the next member would inherit a suppressed
 * card — the entries are keyed by subscription id, so they can never match
 * another account's membership — but because each one names a Stripe
 * subscription and its commitment end date, and that is one member's data
 * sitting in an unencrypted store after their session is over.
 */
export const clearRenewalDismissals = (): void => {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.removeItem(RENEWAL_DISMISSED_STORAGE_KEY);
  } catch {
    // A blocked or unavailable store must never break sign-out.
  }
};
